export default __webpack_public_path__ + "1979936488efb863543ed5a3f4af47b4.png";